import { ModelsModule } from './models/models.module';
import { ArrayModelServiceModule } from './arrayModel.service';
import { ModelServiceModule } from './model.service';
import { ModelParseServiceModule } from './modelParse.service';
import { ModelWatchServiceModule } from './modelWatch.service';

export const ModelModule = angular
    .module('app.services.data.model', [
        ModelsModule,
        ArrayModelServiceModule,
        ModelServiceModule,
        ModelParseServiceModule,
        ModelWatchServiceModule
    ]).name;


// WEBPACK FOOTER //
// ./src/app/services/data/model/model.module.js